module.exports = __webpack_public_path__ + "img/KinokoTable07.31dd93dc.jpg";